module.exports = function () {
    $(document).ready(function () {

        var helper = require('./helper');
        var htmlSelected = '<span><i class="glyphicon glyphicon-ok"></i></span>Selected room';
        var htmlNotSelected = '<span><i class="glyphicon glyphicon-menu-right"></i></span>Assign here';
        let guardians = $('.guardians');
        let selectedGuardians = [];
        let assignGuardians = require('./helpers/assign-helper').assignGuardians;

        selectedGuardians = assignGuardians(guardians, selectedGuardians);

        /*********************
         * TYPEAHEAD SECTION *
         *********************/
        /** Make engine object */
        var searchProperties = new Bloodhound({
            datumTokenizer: function (datum) {
                return Bloodhound.tokenizers.whitespace(datum.name);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: helper.getOrigin() + "/api/properties/search/%QUERY",
                wildcard: '%QUERY'
            },
            filter: function (response) {
                return $.map(response.properties, function (object) {
                    return {
                        id: object.id,
                        name: object.name,
                        property_id: object.property_id
                    };
                });
            }
        });

        /** Run TypeAhead Property*/
        $('.typeahead-property').typeahead(null, {
            minLength: 1,
            display: 'name',
            valueKey: 'id',
            name: 'suggestions',
            displayKey: 'name',
            limit: 15,
            templates: {
                empty: ['<div class="empty-message" style="padding: 10px;"><strong>', 'Unable to find properties', '</strong></div>'].join('\n'),
                suggestion: function (data) {
                    return '<p style="font-size: 100%; cursor: pointer;"><strong>' + data.name + ' (' + data.property_id + ')' + '</strong></p>';
                }
            },
            source: searchProperties
        });

        $('#property').bind('typeahead:select', function (ev, suggestions) {
            $('#injectBox').empty();
            var propertyId = suggestions.id;
            $('#propertyId').val(propertyId);
            if ($('#propertyId').val() != '') {
                $('#injectForm').submit();
            }
        });

        let searchGuardians = new Bloodhound({
            datumTokenizer: function (datum) {
                return Bloodhound.tokenizers.whitespace(datum.value);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: helper.getOrigin() + "/api/guardians/search/%QUERY",
                wildcard: '%QUERY'
            }
        });

        /** Run TypeAhead Guardian*/
        $('.typeahead-guardian').typeahead(null, {
            highlight: true,
            limit: 20,
            minLength: 1,
            valueKey: 'id',
            displayKey: function(guardian) {
                return guardian.user.first_name + ' ' + guardian.user.last_name + ' (' + guardian.unique_guardian_number + ')' ;
            },
            name: 'guardians',
            templates: {
                empty: ['<div class="empty-message" style="padding: 10px;"><strong>', 'Unable to find guardians', '</strong></div>'].join('\n'),
                suggestion: function (guardian) {
                    return '<p style="font-size: 100%; cursor: pointer;"><strong>' + guardian.user.first_name + ' ' + guardian.user.last_name + ' (' + guardian.unique_guardian_number + ')' + '</strong></p>';
                }
            },
            source: searchGuardians
        });

        $('#guardian').bind('typeahead:select', function (ev, guardian) {
            $('#second_guardian_in_room').val(guardian.id);
            let data = '<table class="table-list fs-13 mt-20">' +
                            '<tr>' +
                                '<td class="table-list-header">Guardian ID:</td>' +
                                '<td>' + guardian.unique_guardian_number + '</td>' +
                            '</tr>' +
                            '<tr>' +
                                '<td class="table-list-header">Name:</td>' +
                                '<td>' + guardian.user.first_name + ' ' + guardian.user.last_name + '</td>' +
                            '</tr>' +
                            '<tr>' +
                                '<td class="table-list-header">Phone number:</td>' +
                                '<td>' + guardian.user.phone_number + '</td>' +
                            '</tr>' +
                            '<tr>' +
                                '<td class="table-list-header">Email:</td>' +
                                '<td>' + guardian.user.email + '</td>' +
                            '</tr>' +
                        '</table>';

            $('#second-guardian').html(data);
        });

        if ($('#propertyId').val()) {
            let showModalIfNoSpaceInProperty = require('./helpers/assign-helper.js').showModalIfNoSpaceInProperty,
                numberOfSpecesInRoom = require('./helpers/assign-helper').numberOfSpecesInRoom,
                getPriceOfSelectedRoom = require('./helpers/assign-helper').getPriceOfSelectedRoom,
                getOldRentsOfGuardian = require('./helpers/assign-helper').getOldRentsOfGuardian,
                swal = require('sweetalert2'),
                propertyId = $('#propertyId').val(),
                propertyName = $('.property-name').first().text(),
                spaces,
                roomId ,
                roomName,
                keyNumber,
                rooms = $('.assign-button'),
                roomPrice,
                oldRentsData,
                rentsData;

            oldRentsData = getOldRentsOfGuardian(selectedGuardians, oldRentsData);
            rentsData = getOldRentsOfGuardian(selectedGuardians, rentsData);

            updateAllRoomsVisibility(selectedGuardians);

            $('#guardian').bind('typeahead:select', function (ev, guardian) {
                selectedGuardians.push(guardian.id);
                updateAllRoomsVisibility(selectedGuardians);

                selectedGuardians.splice($.inArray(guardian.id, selectedGuardians), 1);

                let html = $('#selected-guardian-' + selectedGuardians[0]).wrap('<p/>').parent().html();
                html += '<span id="selected-guardian-' + guardian.id + '"><dt>Name:</dt><dd>' + guardian.user.first_name + ' ' + guardian.user.last_name + '</dd></span>';

                $('#selectedGuardian').html('').append(html);
                selectedGuardians.push(guardian.id);
            });

            guardians.on('change', function () {
                updateSelectedGuardians($(this));

                if (roomId) {
                    spaces = numberOfSpecesInRoom(roomId, spaces);

                    if (selectedGuardians.length > spaces) {

                        swal({
                            title: "There is not enough space in selected room. Please select other room.",
                            type: "warning",
                        });

                        updateAssignVisibility(roomId, selectedGuardians);
                        resetSelectedRoomBox();
                    } else {
                        showModalIfNoSpaceInProperty(propertyId, selectedGuardians.length);
                    }
                }

                updateAllRoomsVisibility(selectedGuardians);
            });

            $('.form-checkbox').on('change', function () {
                updateRentsData();
            });

            $('.js-payment-part').on('change', function () {
                updateRentsData();
            });


            /******************************
             * SELECT ROOM EVENT (EFFECT) *
             ******************************/
            /** Select room effect and passing variables from selected elements */
            $('[id^="label-assign-to-"]').on('click', function () {
                /** Get ID of clicked label */
                let id = this.id.substring(16, this.id.length);

                /** Reset last box to 'missing' state */
                resetSelectedRoomBox();

                /** Check (by color of label) whether room was already selected */
                if ( $('#label-assign-to-' + id).css('background-color') != "rgb(156, 255, 164)" ) {

                    showModalIfNoSpaceInProperty(propertyId, selectedGuardians.length); //compare with selected guardians? or not?

                    /** Set all labels as inactive*/
                    $('[id^="button-assign-to-"]').html(htmlNotSelected);
                    $('[id^="label-assign-to-"]').css('background-color', '#e0e0e0');

                    /** Set selected label as active*/
                    $('#button-assign-to-' + id).html(htmlSelected);
                    $('#label-assign-to-' + id).css('background-color', "rgb(156, 255, 164)");

                    /** Get values from selected room container and put it to one html variable */
                    roomId = $('#room-number-' + id).text();
                    roomName = $('#room-name-' + id).text();
                    keyNumber = $('#key-number-' + id).text();

                    roomPrice = getPriceOfSelectedRoom(roomId, roomPrice);

                    /** Add variable to Confirmation container */
                    $('#selectedRoom-room-name').html( roomName );
                    $('#selectedRoom-room-key-number').html( keyNumber );

                    /** Add the same to form hidden elements  */
                    $('.selectedRoom-room-id').val( roomId );
                    $('.selectedRoom-room-key-number').val( keyNumber );

                    /** Set box color as success */
                    $('#roomsWell').addClass('well well-success');

                    /** Set room price in payments form */
                    setPayments(roomPrice);
                    updateRentsData();
                } else {
                    /** Set as not selected and clear box */
                    $('#label-assign-to-' + id).css('background-color', '#e0e0e0');
                    $('#button-assign-to-' + id).html(htmlNotSelected);
                    $('#roomsWell').removeClass('well-success');

                    roomId = undefined;
                }
            });

            $('select[name="guardian_officer_id"]').on('change', function () {
                $('input[name="guardian_officer_id"]').val($(this).val());
            });

            function updateSelectedGuardians(checkbox) {
                let value = checkbox.val();

                if(checkbox.prop('checked') === false){
                    if ($.inArray(value, selectedGuardians) !== -1) {
                        selectedGuardians.splice($.inArray(value, selectedGuardians), 1);
                        $('#state-' + value).text('Staying');
                        $('#state-' + value).css('color', 'green');

                        $('#property-guardian-'+value).text(oldRentsData[value].propertyName);
                        setLicenseFee(value, oldRentsData[value].license_fee);
                        setKeyFee(value, oldRentsData[value].damage_security_payment);
                        $('#selected-guardian-'+value).css('visibility', 'hidden');

                        updateRentsData();
                    }
                } else {
                    if ($.inArray(value, selectedGuardians) < 0) {
                        selectedGuardians.push(value);
                        $('#state-' + value).text('Moving').css('color', 'red');

                        $('#property-guardian-' + value).text(propertyName);
                        setLicenseFee(value, roomPrice);
                        setKeyFee(value, roomPrice);
                        $('#selected-guardian-' + value).css('visibility', 'visible');

                        updateRentsData();
                    }
                }

                return selectedGuardians;
            }

            function updateAllRoomsVisibility(selectedGuardians) {
                rooms.each(function () {
                    let id = $(this).attr('id').substring(16, $(this).attr('id').length);

                    updateAssignVisibility(id, selectedGuardians);
                });
            }


            function updateAssignVisibility(roomId, selectedGuardians) {

                let roomSpaces;

                roomSpaces = numberOfSpecesInRoom(roomId, roomSpaces);

                if (roomSpaces < selectedGuardians.length) {
                    $('#label-assign-to-' + roomId).css('visibility', 'hidden');
                } else {
                    $('#label-assign-to-' + roomId).css('visibility', 'visible');
                }
            }

            function resetSelectedRoomBox() {
                $('#selectedRoom-room-name').empty().html( '<span style="color: red;">Missing</span>' );
                $('#selectedRoom-room-key-number').empty().html( '<span style="color: red;">Missing</span>' );
                $('.selectedRoom-room-id').val( '' );
                $('.selectedRoom-room-key-number').val( '' );
                $('#roomsWell').removeClass('well-success');
            }

            function setPayments(roomPrice) {
                selectedGuardians.forEach(function (item) {
                    setLicenseFee(item, roomPrice);
                    setKeyFee(item, roomPrice);
                })
            }

            function setLicenseFee(guardianId, fee) {
                let guardianBox = $('#guardian-' + guardianId).find('input[name="payments[' + guardianId + '][license_fee]"]');

                guardianBox.val(fee);
                guardianBox.trigger('change');
        }

            function setKeyFee(guardianId, fee) {
                let guardianBox = $('#guardian-' + guardianId).find('input[name="payments[' + guardianId + '][damage_security_payment]"]');

                guardianBox.val(fee);
                guardianBox.trigger('change')
        }

            function updateRentsData() {

            $.each( rentsData, function( key, data ) {
                rentsData[key]['propertyId'] = oldRentsData[key]['propertyId'];
                rentsData[key]['propertyName'] = oldRentsData[key]['propertyName'];
                rentsData[key]['roomId'] = oldRentsData[key]['roomId'];
                rentsData[key]['license_fee'] = $('#guardian-' + key).find('input[name="payments[' + key + '][license_fee]"]').val();
                rentsData[key]['damage_security_payment'] = $('#guardian-' + key).find('input[name="payments[' + key + '][damage_security_payment]"]').val();
                rentsData[key]['pay_gas'] = oldRentsData[key]['payGas'];
                rentsData[key]['pay_electric'] = oldRentsData[key]['payElectric'];
                rentsData[key]['pay_water'] = oldRentsData[key]['payWater'];
                rentsData[key]['pay_council_tax'] = oldRentsData[key]['payCouncilTax'];

                if ($.inArray(key, selectedGuardians) !== -1 && roomId) {
                    rentsData[key]['propertyId'] = parseInt(propertyId);
                    rentsData[key]['propertyName'] = propertyName;
                    rentsData[key]['roomId'] = roomId;
                    rentsData[key]['pay_gas'] = $('#guardian-' + key).find('input:radio[name="payments[' + key + '][pay_gas]"]:checked').val();
                    rentsData[key]['pay_electric'] = $('#guardian-' + key).find('input:radio[name="payments[' + key + '][pay_electric]"]:checked').val();
                    rentsData[key]['pay_water'] = $('#guardian-' + key).find('input:radio[name="payments[' + key + '][pay_water]"]:checked').val();
                    rentsData[key]['pay_council_tax'] = $('#guardian-' + key).find('input:radio[name="payments[' + key + '][pay_council_tax]"]:checked').val();
                }
            });
        }

            $('form').on('submit', function (e) {
                if ($(':submit').hasClass('js-move-submit')) {
                    $.each(rentsData, function (key, data) {
                        let id = key,
                            submit = $('.js-move-submit');

                        $.each(data, function (key, value) {
                            $('<input name="selectedGuardians['+id+']['+key+']" type="hidden" value="'+value+'">').insertBefore(submit);
                        });
                    });

                    return true;
                }

                if ($(':submit').hasClass('js-assign-submit')) {
                    $.each(selectedGuardians, function (key, guardian) {
                        let submit = $('.js-assign-submit');

                        $('<input name="selectedGuardians[' + key + ']" type="hidden" value="'+ guardian +'">').insertBefore(submit);
                    });

                    return true;
                }
            })
        }
    });
}();


